if (process.env.REACT_APP_ENVIRONMENT === undefined) {
  throw new Error("Please define REACT_APP_ENVIRONMENT in .env file");
}
if (process.env.REACT_APP_PAYPAL_CLIENT_ID === undefined) {
  throw new Error("Please define PAYPAL_CLIENT_ID in .env file");
}
export const PHP_BACKEND_URL = process.env.REACT_APP_PHP_BACKEND_URL;
if (process.env.REACT_APP_DJANGO_API_URL === undefined) {
  throw new Error("Please define REACT_APP_DJANGO_API_URL in .env file");
}
if (process.env.REACT_APP_UTIL_API_URL === undefined) {
  throw new Error("Please define REACT_APP_UTIL_API_URL in .env file");
}
if (process.env.REACT_APP_WRITE_API_URL === undefined) {
  throw new Error("Please define REACT_APP_WRITE_API_URL  in .env file");
}

export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;
export const BACKEND_URL = process.env.REACT_APP_DJANGO_API_URL;
export const BACKEND_CDN_URL = process.env.REACT_APP_DJANGO_API_CDN_URL;
export const BACKEND_LATEST_URL = process.env.REACT_APP_DJANGO_API_LATEST_URL;
export const PAYPAL_CLIENT_ID = process.env.REACT_APP_PAYPAL_CLIENT_ID;
export const SALE_START_DATE = process.env.REACT_APP_SALE_START_DATE
  ? new Date(process.env.REACT_APP_SALE_START_DATE)
  : new Date(null);
export const SALE_END_DATE = process.env.REACT_APP_SALE_END_DATE
  ? new Date(process.env.REACT_APP_SALE_END_DATE)
  : new Date(null);
export const SALE_ACTIVE = process.env.REACT_APP_SALE_ACTIVE === "true";
export const AUTH_TOKEN = process.env.REACT_APP_AUTH_TOKEN;
export const UTIL_API = process.env.REACT_APP_UTIL_API_URL;
export const AUTH_URL = process.env.REACT_APP_AUTH_URL;
export const GFG_API = "https://api.geeksforgeeks.org/post/api";
export const WRITE_URL = process.env.REACT_APP_WRITE_API_URL;
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
export const ONE_TAP_URL = `${process.env.REACT_APP_AUTH_DJANGO_API_URL}/google-verify/`;
